import { RouteObject } from "react-router-dom";
import { SupportPage } from "./ui";

export const supportRoute: RouteObject = {
  path: "/support",
  element: <SupportPage />,
};
